import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { cpvBaseAPI } from "./cpv.base.api";
import { API_CPV_URL } from "@/commons/config";
export class cpvAPI extends cpvBaseAPI<any> {
  constructor() {
    super();
    this.cpvVereadorAPIUrl += `central-servicos-vereador`;
    this.cpvCamaraAPIUrl += `central-servicos-camara`;
    this.cpvVeiculoAPIUrl += `central-servicos-veiculo`;
  }

private buildParams(params: Record<string, any>) {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (
      value !== undefined &&
      value !== null &&
      value !== ''
    ) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, any>);
}


  // Lista grid vereadores
  public listVereadores(params): AxiosObservable<any> {
    const queryParams = this.buildParams({
      camaraId: params.camaraId,
      id: params.id,
      cpf: params.cpf,
      nome: params.nome,
      placa: params.placa,
      situacaoMandato: params.situacaoMandato,
      dataInicioMandato: params.dataInicioMandato,
      dataFimMandato: params.dataFimMandato,
      page: params.pageIndex,
      size: params.pageSize,
    });

    return this.axios.get(this.cpvVereadorAPIUrl, {
      params: queryParams,
    });
  }

  // Detalhamento Vereador
  public getById(id: number): AxiosObservable<any> {
    return this.axios.get(`${this.cpvVereadorAPIUrl}/id`,
      {
        params: {
          id: id
        }
      }
    );
  }
  // Encerrar Mandato
  public endMandateById(id: number): AxiosObservable<any> {
    return this.axios.patch(
      `${this.cpvVereadorAPIUrl}/encerrarMandato/${id}`
    );
  }

  //Vereador pode atualizar veículo??
  public vereadorCanUpdateVehicle(vereadorId: number): AxiosObservable<any> {
     return this.axios.get(
       `${this.cpvVereadorAPIUrl}/podeSubstituirVeiculo`,
       {
        params: {
          vereadorId: vereadorId
        }
       }
     );
   }

  // Check da placa no detran
  public checkPlateOnDetran(plate: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.cpvVeiculoAPIUrl}/findByPlacaOnDetran`,
      { params: { placaOnDetran: plate } }
    );
  }

  // Listar Veículos
  public listVehicles(params): AxiosObservable<any> {
    const queryParams = this.buildParams({
      vereadorId: params.vereadorId,
      camaraId: params.camaraId,
      id: params.id,
      placa: params.placa,
      marcaModelo: params.marcaModelo,
      cor: params.cor,
      anoFabricacao: params.anoFabricacao,
      dataFimVigencia: params.dataFimVigencia,
      ativo: params.ativo
    });
    return this.axios.get(this.cpvVeiculoAPIUrl, {
      params: queryParams,
    });
  }

  // Consulta de veículo
  public getVehiclebyPlate(plate: string):AxiosObservable<any> {

    return this.axios.get(`${this.cpvVeiculoAPIUrl}/historicoPorPlaca`,
      {
        params: {
          placa: plate
        }
      }
    );
  }
  
  // Dashboard Data
  public retriveDashboardData(presidenteId: string):AxiosObservable<any> {

    return this.axios.get(`${this.cpvCamaraAPIUrl}/dashBoardCamara`,
      {
        params: {
          presidenteId: presidenteId
        }
      }
    );
  }

  //Atualizar placa do veículo
  public updateVehiclePlate(formData: FormData): AxiosObservable<any> {
    return this.axios.post(
      `${this.cpvVereadorAPIUrl}/substituiVeiculoAtivo`,
       formData
    );
  }

  public createVereador(formData: FormData): AxiosObservable<any> {
    return this.axios.post(
      `${this.cpvVereadorAPIUrl}/vereador`,
      formData
    )
  }

  public patchVereador(
  id: number,
  payload: {
    id: number;
    cpf: string;
    nome: string;
    telefone: string;
    email: string;
    dataFimVigencia: string;
    situacaoMandato: string;
    camaraId: string;
  }
): AxiosObservable<any> {
  return this.axios.patch(
    `${this.cpvVereadorAPIUrl}/atualiza/${id}`,
    payload
  );
}

  public downloadAutorizacaoVeicular(veiculoId: number): AxiosObservable<Blob> {
    return this.axios.get(
      `${this.cpvVeiculoAPIUrl}/${veiculoId}/certidao`,
      {
        responseType: 'blob',
      }
    );
  }

  public validateCertidaoVeicular(token: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.cpvVeiculoAPIUrl}/validar-certidao`,
      {
        params: { token },
      }
    );
  }
}
